import {
  EmployeeScopeFilter,
  useDashboardAnniversariesQuery,
} from '../../../__generated__/graphql';
import { FilterOption } from '../CommonComponents/WidgetFilter/types';
import { useState } from 'react';

const useAnniversariesData = (initialFilterBy = EmployeeScopeFilter.MyTeam) => {
  const [filterBy, setFilterBy] = useState(initialFilterBy);
  const { data, loading, error } = useDashboardAnniversariesQuery({
    variables: {
      filter: {
        limit: 3,
        filterBy,
      },
    },
  });

  const handleChangeFilter = (filter: string) => {
    if (filter === FilterOption.MY_TEAM.toString()) {
      setFilterBy(EmployeeScopeFilter.MyTeam);
    } else {
      setFilterBy(EmployeeScopeFilter.AllCompany);
    }
  };

  return {
    data,
    loading,
    error,
    filterBy,
    handleChangeFilter,
  };
};

export default useAnniversariesData;
